// extracted by mini-css-extract-plugin
module.exports = {"list":"List__list___2jYpS","table":"List__table___mhAPn"};